// import Swiper
import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

// Homepage header
new Swiper('.home > .swiper', {
    modules: [Navigation, Pagination, Autoplay],
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletActiveClass: 'active-link',
        bulletClass: 'nav-link w-full bg-white flex transition-opacity hover:opacity-80',
        renderBullet: (index, className) => (`
            <li class="${className}">
                <a href="#" class="w-full h-full flex items-center justify-between border-r border-neutral-200 py-5 px-7">
                    ${document.querySelector('.home > .swiper .swiper-slide:nth-child(' + (index+1) +')').getAttribute('data-title')}
                </a>
            </li>
        `),
    },
    slidesPerView: 'auto',
    autoplay: {
        delay: 6000,
    },
    speed: 1500
});


// Magazine items carousel
new Swiper('.magazine-carousel-organisms .carousel', {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 20,
    navigation: {
        nextEl: '.carousel-button-next',
        prevEl: '.carousel-button-prev',
    },
});
